import { useHabits } from 'features/tasks';
import React from 'react';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { useUser } from 'shared/hooks/use-user';
import { PageEvents } from 'shared/services/tracking';
import { GroupByMode, HabitGroupBy } from 'shared/types/sorting-mode';

import { ArchivedHabitsList } from './components/archived-habits-list';
import { CompletedHabitsList } from './components/completed-habits-list';
import { EmptyHabitsList } from './components/empty-habits-list';
import { GoalGroupingHabitsList } from './components/goal-grouping-habits-list';
import { LifeAreaGroupingHabitsList } from './components/life-area-grouping-habits-list';
import { MobileAddTaskButton } from './components/mobile-add-task-button';
import { NoGroupingHabitsList } from './components/no-grouping-habits-list';
import { PageTopBar } from './components/page-top-bar';
import { PriorityGroupingHabitsList } from './components/priority-grouping-habits-list';
import { TimeframeProvider } from './contexts/timeframe';
import * as Styled from './habits-overview.style';

const groupByLists: Record<HabitGroupBy, React.FC> = {
  [HabitGroupBy.None]: NoGroupingHabitsList,
  [HabitGroupBy.Goal]: GoalGroupingHabitsList,
  [HabitGroupBy.LifeArea]: LifeAreaGroupingHabitsList,
  [HabitGroupBy.Priority]: PriorityGroupingHabitsList,
};

export const HabitsOverview: React.FC = () => {
  useTrackPageVisitEvent(PageEvents.Habits, undefined);
  const user = useUser();

  const habits = useHabits({
    uncompletedOnly: true,
    unArchivedOnly: true,
    undeletedOnly: true,
  });

  const HabitListComponent =
    groupByLists[user?.settings?.habitGroupBy ?? GroupByMode.None] ??
    groupByLists[HabitGroupBy.None];

  return (
    <TimeframeProvider>
      <Styled.Container>
        <Styled.Main>
          <Styled.MainContent>
            <PageTopBar />

            <Styled.Content>
              {habits.length ? (
                <>
                  <HabitListComponent />
                  <CompletedHabitsList />
                  <ArchivedHabitsList />
                </>
              ) : (
                <EmptyHabitsList />
              )}
            </Styled.Content>
          </Styled.MainContent>
        </Styled.Main>

        <MobileAddTaskButton />
      </Styled.Container>
    </TimeframeProvider>
  );
};
